import React, { useState } from 'react'
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifCheckbox,
} from '@ey-xd/motif-react'

export default function PrivacyNoticeModal({
  open,
  onAgree,
}: {
  open: boolean
  onAgree: () => void
}) {
  const [checked, setChecked] = useState(false)

  return (
    <MotifModal show={open} size="md" onClose={() => {}}>
      <MotifModalBody>
        <h2>Privacy Notice</h2>
        <p>
          For employees in Canada, view policy&nbsp;
          <a
            href="https://discovercontent.ey.net/pop22082463th9d2"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </p>
        <p>
          For employees in the US, view policy&nbsp;
          <a
            href="/privacy_policy/US_SOD_Privacy_Notice.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </p>
        <MotifCheckbox checked={checked} onChange={() => setChecked(!checked)}>
          I agree to the privacy notice
        </MotifCheckbox>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton disabled={!checked} onClick={onAgree} variant="primary">
          Continue
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  )
}
